/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Please_ChooseInputs */

const en_please_choose = /** @type {(inputs: Please_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please choose`)
};

const de_please_choose = /** @type {(inputs: Please_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen`)
};

/**
* | output |
* | --- |
* | "Please choose" |
*
* @param {Please_ChooseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const please_choose = /** @type {((inputs?: Please_ChooseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Please_ChooseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_please_choose(inputs)
	return en_please_choose(inputs)
});